export default __webpack_public_path__ + "static/tutor-screen@2x-9cd25f88ed27168f2ff7b0a09ebd0aa1.png";